<template>
  <div>
    <!-- <home-header></home-header> -->
    <header-hut-reward />
    <home-top></home-top>
    <slot></slot>
    <!--<home-dinein></home-dinein>-->
    <home-popular-deal></home-popular-deal>
    <home-footer></home-footer>

    <!--<div id="coupon-fixed"
         v-on:click.stop="redirectToMenuPage($const.HEADER_MENU.COUPON)"
         v-show="isShowCoupon">
      <img v-if="$i18n.locale == $const.LANG_JP"
           src="https://static.pizzahut.jp/jp/images/coupon-popup-jp-1.png"/>
      <img v-else
           src="https://static.pizzahut.jp/jp/images/coupon-popup-en.png"/>
    </div>-->
  </div>
</template>
<script>
import {
  mapGetters,
  mapActions
} from 'vuex'
import * as types from '@/store/types'

export default {
  components: {
    HomeHeader: () => import('@/components/home/HomeHeader.vue'),
    HomeTop: () => import('@/components/home/HomeTop.vue'),
    HomePopularDeal: () => import('@/components/home/HomePopularDeal.vue'),
    HomeFooter: () => import('@/components/home/HomeFooterJP.vue'),
    HeaderHutReward: () => import('@/components/partials/HeaderHutReward.vue')
  },
  computed: {
    ...mapGetters({
      isLandOnHomepageFirst: types.GET_LAND_ON_HOMEPAGE
    })
  },
  data() {
    return {
      isShowCoupon: true,
    }
  },
  mounted() {
    let body = document.body

    body.classList.remove('mainpage')
    body.classList.remove('mainpage-combo')
    body.classList.remove('combo-popup-items')
    this.checkIsLandOnHomepage(true)
  },
  methods: {
    closeCouponPopup: function () {
      this.isShowCoupon = !this.isShowCoupon
    },
    ...mapActions({
      checkIsLandOnHomepage: types.CHECK_IS_LAND_ON_HOMEPAGE
    })
  }
}
</script>
<style>
  body {
    padding-right: 0px;
    background: none;

  }
</style>



// WEBPACK FOOTER //
// src/layouts/Home.vue